export default __webpack_public_path__ + "static/media/bg-polisport-molds.b755fc1f.jpg";